import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IDoctor } from 'src/app/interfaces/record.interfaces';
import { ConfigService } from 'src/app/services/application/config.service.';

@Component({
    selector: 'app-doc-info-modal',
    templateUrl: './doc-info-modal.component.html',
    styleUrls: ['./doc-info-modal.component.scss'],
    standalone: false
})
export class DocInfoModalComponent {
    public doc!: IDoctor;
    public spec!: string;

    public constructor(
        private config: ConfigService,
        private activeModal: NgbActiveModal,
    ) {}

    @ViewChild('modalBody')
    public modalBody!: ElementRef;
    @ViewChild('header')
    public header!: ElementRef;

    public ngAfterViewInit() {
        if (this.modalBody && this.modalBody.nativeElement) {
            this.modalBody.nativeElement.addEventListener(
                'scroll',
                this.handleScroll.bind(this),
            );
        }
    }

    public ngOnDestroy() {
        if (this.modalBody && this.modalBody.nativeElement) {
            this.modalBody.nativeElement.removeEventListener(
                'scroll',
                this.handleScroll,
            );
        }
    }

    public handleScroll() {
        if (this.modalBody && this.header) {
            const scrollTop = this.modalBody.nativeElement.scrollTop;

            if (scrollTop > 0) {
                this.header.nativeElement.classList.add('scrolled');
            } else {
                this.header.nativeElement.classList.remove('scrolled');
            }
        }
    }

    public getDocImg(id: number) {
        return `${this.config.getValue('hostBackend')}/img/doc/${id}.png`;
    }

    public getDocImgDefault(event: Event) {
        const elem = event.target as HTMLImageElement;
        // elem.src = `${this.config.getValue('hostBackend')}/img/doc/not.png`;
        elem.src = './assets/images/placeholders/doctor-photo.png';
    }

    public closeModal(e: Event) {
        e.stopPropagation();
        this.activeModal.close();
    }
}
